module.exports = __webpack_public_path__ + "static/media/DIPCHIP_icon.46c5e9ea.png";